import { fetchBaseQuery } from '@reduxjs/toolkit/dist/query'

import { logout } from '../redux/reducers/authReducer'

export const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_BASE_URL,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem('jwtToken')

    if (token) {
      headers.set('Authorization', `Bearer ${token}`)
    }
    return headers
  },
})

export const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions)
  if (result.error && result.error.status === 401) {
    api.dispatch(logout())
    result = await baseQuery(args, api, extraOptions)
  }

  return result
}
